import React from 'react';
import { CloseOutlined, DownOutlined, PlusOutlined } from '@ant-design/icons';

interface Props {
  title: string;
  onNewSession: () => void;
  onToggleHistory: () => void;
  onClose: () => void;
  historyOpen: boolean;
  newSessionDisabled?: boolean;
}

const headerBtnStyle = (color: string, bg?: string): React.CSSProperties => ({
  width: 28,
  height: 28,
  borderRadius: 8,
  border: 'none',
  background: bg || 'transparent',
  color,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'all 0.15s'
});

export default function SessionHeader({
  title,
  onNewSession,
  onToggleHistory,
  onClose,
  historyOpen,
  newSessionDisabled
}: Props) {
  return (
    <div
      style={{
        padding: '14px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        borderBottom: '1px solid #F0F0F0',
        flexShrink: 0,
        position: 'relative',
        zIndex: 3
      }}
    >
      <div
        style={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #2A6FF5, #5B8DEF)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          marginRight: 6
        }}
      >
        <svg viewBox="0 0 24 24" fill="none" width={18} height={18}>
          <path d="M14 2L5 13.5h6.5L10 22l9.5-11H13L14 2Z" fill="#fff" />
        </svg>
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: 15,
            fontWeight: 700,
            color: '#262626',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
          title={title}
        >
          {title || '新会话'}
        </div>
      </div>
      <button
        type="button"
        title={newSessionDisabled ? '当前已是新会话' : '新建对话'}
        disabled={newSessionDisabled}
        onClick={onNewSession}
        style={{
          ...headerBtnStyle('#595959'),
          color: newSessionDisabled ? '#BFBFBF' : '#595959',
          cursor: newSessionDisabled ? 'not-allowed' : 'pointer'
        }}
        onMouseEnter={(e) => {
          if (!newSessionDisabled) e.currentTarget.style.background = '#F5F5F5';
        }}
        onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
      >
        <PlusOutlined style={{ fontSize: 14 }} />
      </button>
      <button
        type="button"
        title={historyOpen ? '收起历史对话' : '展开历史对话'}
        onClick={onToggleHistory}
        style={headerBtnStyle(historyOpen ? '#1677FF' : '#595959', historyOpen ? '#E6F0FF' : 'transparent')}
        onMouseEnter={(e) => {
          if (!historyOpen) e.currentTarget.style.background = '#F5F5F5';
        }}
        onMouseLeave={(e) => {
          if (!historyOpen) e.currentTarget.style.background = 'transparent';
        }}
      >
        <DownOutlined
          style={{
            fontSize: 12,
            transform: historyOpen ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.2s'
          }}
        />
      </button>
      <div style={{ width: 4 }} />
      <button
        type="button"
        title="关闭"
        onClick={onClose}
        style={headerBtnStyle('#8C8C8C')}
        onMouseEnter={(e) => (e.currentTarget.style.background = '#F5F5F5')}
        onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
      >
        <CloseOutlined style={{ fontSize: 12 }} />
      </button>
    </div>
  );
}
